/**
 * Returns the correct Russian plural form based on the count.
 *
 * @param count - The number to pluralize
 * @param one - Form for 1, 21, 31, etc. (e.g., "товар")
 * @param few - Form for 2-4, 22-24, etc. (e.g., "товара")
 * @param many - Form for 5-20, 25-30, etc. (e.g., "товаров")
 * @returns The correct plural form
 *
 * @example
 * pluralize(1, 'товар', 'товара', 'товаров') // "товар"
 * pluralize(2, 'товар', 'товара', 'товаров') // "товара"
 * pluralize(5, 'товар', 'товара', 'товаров') // "товаров"
 * pluralize(21, 'товар', 'товара', 'товаров') // "товар"
 * pluralize(22, 'товар', 'товара', 'товаров') // "товара"
 */
export function pluralize(count: number, one: string, few: string, many: string): string {
  const mod10 = count % 10;
  const mod100 = count % 100;

  if (mod100 >= 11 && mod100 <= 19) {
    return many;
  }

  if (mod10 === 1) {
    return one;
  }

  if (mod10 >= 2 && mod10 <= 4) {
    return few;
  }

  return many;
}
